import { render, staticRenderFns } from "./r-trigger-smart-offer.vue?vue&type=template&id=b16de874&scoped=true"
import script from "./r-trigger-smart-offer.vue?vue&type=script&lang=js"
export * from "./r-trigger-smart-offer.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-smart-offer.vue?vue&type=style&index=0&id=b16de874&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16de874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b16de874')) {
      api.createRecord('b16de874', component.options)
    } else {
      api.reload('b16de874', component.options)
    }
    module.hot.accept("./r-trigger-smart-offer.vue?vue&type=template&id=b16de874&scoped=true", function () {
      api.rerender('b16de874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-smart-offer.vue"
export default component.exports